import $, { event } from "jquery";
window.$ = $;
import 'bootstrap';
import "slick-carousel";
import "select2";
import './styles/index.scss';

// СКРЫТЬ ИЛИ ПОКАЗАТЬ ПАРОЛЬ ФОРМЫ

const btn = document.querySelector('.password__btn');
const input = document.querySelector('.password__input');

if (btn && input) {
  btn.addEventListener('click', () => {
    btn.classList.toggle('active')

    if (input.getAttribute('type') === 'password') {
      input.setAttribute('type', 'text')
    } else {
      input.setAttribute('type', 'password')
    }
  })
}

// НАСТРОЙКА АКТИВНОГО ИЛИ НЕ АКТИВНОГО ЕЛЕМЕНТА
  $( ".tumble" ).on('click', function() {
    $(this).toggleClass( "active")
  });

// НАСТРОЙКА САЙДБАРА

  const body = document.querySelector("body");
  const sidebar = body.querySelector("nav");

  if (body && sidebar) {
    const sidebarToggle = body.querySelector(".sidebar-toggle");
    sidebarToggle.addEventListener('click', () => {
      sidebar.classList.toggle('close')
    }) 
  }

// НАСТРОЙКА ГРАФИКА

import ApexCharts from 'apexcharts'
var options = {
    series: [{
    name: 'series1',
    data: [31, 40, 28, 51, 42, 109, 100]
  }, {
    name: 'series2',
    data: [11, 32, 45, 32, 34, 52, 41]
  }],
    chart: {
    height: 350,
    type: 'area'
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    curve: 'smooth'
  },
  xaxis: {
    type: 'datetime',
    categories: ["2018-09-19T00:00:00.000Z", "2018-09-19T01:30:00.000Z", "2018-09-19T02:30:00.000Z", "2018-09-19T03:30:00.000Z", "2018-09-19T04:30:00.000Z", "2018-09-19T05:30:00.000Z", "2018-09-19T06:30:00.000Z"]
  },
  tooltip: {
    x: {
      format: 'dd/MM/yy HH:mm'
    },
  },
  };
var chart = new ApexCharts(document.querySelector("#chart"), options);
if (chart.el) {
  chart.render();
}

// НАСТРОЙКА ПАГИНАЦИИ

$(document).ready(function() {

  let tbodyData =  [
     
    {avatar: require('./images/referal/1.svg'), contact: "Contact Email not Linked", updated: "Updated 1 day ago" , designation: "Tom Cruise", date: "on 24.05.2019", experience:"May 26, 2019", salary: "6:30 PM", 	priority:  "HIGH", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/2.svg'), contact: "Adding Images to Featured Posts", updated: "Updated 1 day ago" , designation: "Matt Damon", date: "on 24.05.2019", experience:"May 26, 2019", salary: "8:00 PM",priority: "LOW", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/3.svg'), contact: "When will I be charged this month?", updated: "Updated 1 day ago" , designation: "Robert Downey", date: "on 24.05.2019", experience:"May 26, 2019", salary: "7:30 PM", 	priority: "HIGH", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/4.svg'), contact: "Payment not going through", updated: "Updated 2 day ago" , designation: "Christian Bale", date: "on 24.05.2019", experience:"May 25, 2019", salary: "5:00 PM", 	priority: "NORMAL", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/5.svg'), contact: "Unable to add replies", updated: "Updated 2 day ago" , designation: "Henry Cavil", date: "on 24.05.2019", experience:"May 25, 2019", salary: "4:00 PM", 	priority: "HIGH", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/6.svg'), contact: "Downtime since last week", updated: "Updated 3 day ago" , designation: "Chris Evans", date: "on 23.05.2019", experience:"May 25, 2019", salary: "2:00 PM", 	priority: "NORMAL", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/7.svg'), contact: "Referral Bonus", updated: "Updated 4 day ago" , designation: "Sam Smith", date: "on 22.05.2019", experience:"May 25, 2019", salary: "11:30 PM", 	priority: "LOW", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/8.svg'), contact: "How do I change my password?", updated: "Updated 6 day ago" , designation: "Steve Rogers", date: "on 21.05.2019", experience:"May 24, 2019", salary: "1:00 PM", 	priority: "NORMAL", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/1.svg'), contact: "Contact Email not Linked", updated: "Updated 1 day ago" , designation: "Tom Cruise", date: "on 24.05.2019", experience:"May 26, 2019", salary: "6:30 PM", 	priority:  "HIGH", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/2.svg'), contact: "Adding Images to Featured Posts", updated: "Updated 1 day ago" , designation: "Matt Damon", date: "on 24.05.2019", experience:"May 26, 2019", salary: "8:00 PM",priority: "LOW", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/3.svg'), contact: "When will I be charged this month?", updated: "Updated 1 day ago" , designation: "Robert Downey", date: "on 24.05.2019", experience:"May 26, 2019", salary: "7:30 PM", 	priority: "HIGH", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/4.svg'), contact: "Payment not going through", updated: "Updated 2 day ago" , designation: "Christian Bale", date: "on 24.05.2019", experience:"May 25, 2019", salary: "5:00 PM", 	priority: "NORMAL", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/5.svg'), contact: "Unable to add replies", updated: "Updated 2 day ago" , designation: "Henry Cavil", date: "on 24.05.2019", experience:"May 25, 2019", salary: "4:00 PM", 	priority: "HIGH", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/6.svg'), contact: "Downtime since last week", updated: "Updated 3 day ago" , designation: "Chris Evans", date: "on 23.05.2019", experience:"May 25, 2019", salary: "2:00 PM", 	priority: "NORMAL", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/7.svg'), contact: "Referral Bonus", updated: "Updated 4 day ago" , designation: "Sam Smith", date: "on 22.05.2019", experience:"May 25, 2019", salary: "11:30 PM", 	priority: "LOW", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/8.svg'), contact: "How do I change my password?", updated: "Updated 6 day ago" , designation: "Steve Rogers", date: "on 21.05.2019", experience:"May 24, 2019", salary: "1:00 PM", 	priority: "NORMAL", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/7.svg'), contact: "Referral Bonus", updated: "Updated 4 day ago" , designation: "Sam Smith", date: "on 22.05.2019", experience:"May 25, 2019", salary: "11:30 PM", 	priority: "LOW", vertical: require("./images/referal/vertical.svg")}, 
    {avatar: require('./images/referal/8.svg'), contact: "How do I change my password?", updated: "Updated 6 day ago" , designation: "Steve Rogers", date: "on 21.05.2019", experience:"May 24, 2019", salary: "1:00 PM", 	priority: "NORMAL", vertical: require("./images/referal/vertical.svg")}
     
  ];
  var page_number = 1;
  var records_per_page = 8;
  var total_page = Math.ceil(tbodyData.length / records_per_page);

  //Display pagination buttons
  $.fn.displayPaginationButtons = function() {
      var buttons_text =  '<a class="arrow-prev" href="#" onClick="javascript:$.fn.prevPage();"><</a>';
      var active = '';
      for(var i=1; i<=total_page; i++) {
          if(i==1) {
              active = ' active';
          } else {
              active = '';
          }
          // buttons_text = buttons_text + '<a href="#" id="page_index'+i+'" onClick="javascript:$.fn.changePageIndex('+i+');" class="page_index'+active+'">'+i+'</a>';
      }
      buttons_text = buttons_text + '<a class="arrow-next" href="#" onClick="javascript:$.fn.nextPage();">></a>';
      $(".pagination-buttons").text('');
      $(".pagination-buttons").append(buttons_text);
  }
  $.fn.displayPaginationButtons();

  // УСЛОВИЕ ДЛЯ КНОПКИ
  function generatePriorityButton(value) {
    if (value === 'HIGH') {
      return '<button class="buttons buttons-high">'+value+'</button>'
    } else if (value === 'LOW') {
      return '<button class="buttons buttons-low">'+value+'</button>'
    } else if (value === 'NORMAL') {
      return '<button class="buttons buttons-normal">'+value+'</button>'
    } else {
      return 'no priority'
    }
  }

  //Display table rows from json data
  $.fn.displayTableDate = function() {
      var start_index = (page_number - 1) * records_per_page;
      var end_index = start_index + (records_per_page - 1 );
      end_index = (end_index >= tbodyData.length) ? tbodyData.length - 1 : end_index;
      var inner_html = '';
      for(var i=start_index; i<=end_index; i++) {
          inner_html = inner_html+'<tr>'+
                                      '<td class="prevs ticket"><img class="avatar" src="'+tbodyData[i].avatar+'" alt=""><div class="text"> <span>'+tbodyData[i].contact +'</span> <p>'+tbodyData[i].updated+'</p></div></td>'+
                                      '<td class="customer prevs point"><span>'+tbodyData[i].designation+'</span> <p>'+tbodyData[i].date+'</p></td>'+
                                      '<td class="salary prevs point"><span>'+tbodyData[i].experience+'</span><p>'+tbodyData[i].salary+'</p></td>'+
                                      '<td class="prevs point">'+generatePriorityButton(tbodyData[i].priority)+'</td>'+
                                      '<td class="entry"><img src="'+tbodyData[i].vertical+'" alt=""></td>'+
                                  '</tr>';    
      }

      $('table tbody tr').remove();
      $('table tbody').append(inner_html);
      $('.page_index').removeClass('active');
      $('#page_index'+page_number).addClass('active');
      $('.pagination-details').text(+(start_index+1)+' - '+(end_index+1)+' of '+tbodyData.length+' ')
  }

  function deleteItemOfListButton() {
    const idOrIndex = 1234

    tbodyData = tbodyData.filter((item) => item.id !== idOrIndex)

    $.fn.displayTableDate();
  }
 
  $.fn.nextPage = function() {
      page_number++;
      $.fn.displayTableDate();
  }
  $.fn.prevPage = function() {
      page_number--;
      $.fn.displayTableDate();
  }
  // НОМЕРАЦИЯ

  // $.fn.changePageIndex = function(index) {
  //     page_number = parseInt(index);
  //     $.fn.displayTableDate();
  // }

  $('#table-size').change(function() {
      var tab_size = $(this).val();
      page_number = 1;
      records_per_page = parseInt(tab_size);
      total_page = Math.ceil(tbodyData.length / records_per_page);
      $.fn.displayPaginationButtons();
      $.fn.displayTableDate();
  });
  $.fn.displayTableDate();
});
